import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Storage keys - same as AuthContext
const TOKEN_KEY = 'calvio_session_token';
const USER_KEY = 'calvio_user';

const AuthCallback = () => {
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      console.log('AuthCallback: Processing hash:', hash);
      
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.log('AuthCallback: No session_id found in hash');
        window.location.replace('/login');
        return;
      }

      // Decode the session_id in case it's URL encoded
      const sessionId = decodeURIComponent(sessionIdMatch[1]);
      console.log('AuthCallback: Extracted session_id:', sessionId.substring(0, 20) + '...');

      try {
        console.log('AuthCallback: Calling backend /api/auth/session');
        const response = await axios.post(`${API}/auth/session`, {
          session_id: sessionId
        }, { withCredentials: true });

        console.log('AuthCallback: Backend response received', response.data);

        // Store token and user data in localStorage FIRST before any redirect
        const sessionToken = response.data.session_token;
        if (sessionToken) {
          localStorage.setItem(TOKEN_KEY, sessionToken);
          localStorage.setItem(USER_KEY, JSON.stringify(response.data));
          
          // Force a synchronous localStorage flush by reading back
          const verifyToken = localStorage.getItem(TOKEN_KEY);
          const verifyUser = localStorage.getItem(USER_KEY);
          console.log('Auth stored - Token exists:', !!verifyToken, 'User exists:', !!verifyUser);
        }
        
        // Redirect based on onboarding status using window.location for full page reload
        // This ensures AuthContext re-initializes with the stored token
        const redirectTo = response.data.onboarding_complete ? '/dashboard' : '/onboarding';
        console.log('AuthCallback: Redirecting to', redirectTo);
        
        // Use longer delay to ensure localStorage writes are complete before redirect
        setTimeout(() => {
          window.location.replace(redirectTo);
        }, 1500);
      } catch (error) {
        console.error('Auth callback error:', error);
        console.error('Auth callback error response:', error.response?.data);
        window.location.replace('/login');
      }
    };

    processSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFBF5] flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 rounded-full gradient-sage flex items-center justify-center mx-auto mb-6 animate-pulse-slow">
          <Sparkles className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-xl font-serif text-[#2D3748] mb-2">Signing you in...</h2>
        <p className="text-[#718096]">Just a moment</p>
      </div>
    </div>
  );
};

export default AuthCallback;
